/**
 * PDP free-shipping tooltip: position on hover/focus/click
 * Accessible: keyboard focus shows tooltip, aria-expanded and aria-hidden kept in sync.
 */

(function () {
  if (window.__pdpTooltipInited) return;
  window.__pdpTooltipInited = true;

  const TRIGGER = '.pdp-free-shipping-message__tooltip-trigger';
  const TOOLTIP = '.pdp-free-shipping-message__tooltip';
  const WRAPPER = '.pdp-free-shipping-message__wrapper';
  const getTooltip = (el) => document.getElementById(el?.getAttribute('aria-describedby'));

  const SMALL_VIEWPORT = 1049;

  function position(trigger, tooltip) {
    if (!trigger || !tooltip) return;
    const r = trigger.getBoundingClientRect();
    const centerX = r.left + r.width / 2;
    const isSmall = window.innerWidth <= SMALL_VIEWPORT;
    Object.assign(tooltip.style, {
      position: 'fixed',
      left: centerX + 'px',
      top: 'auto',
      bottom: (window.innerHeight - r.top + 10) + 'px',
      transform: isSmall ? 'translateX(-3%)' : 'translateX(-50%)'
    });
  }

  function open(trigger, tooltip) {
    tooltip.classList.add('is-visible');
    tooltip.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    position(trigger, tooltip);
  }

  function close(tooltip) {
    if (!tooltip) return;
    const trigger = document.querySelector(`[aria-describedby="${tooltip.id}"]`);
    const shouldRestoreFocus = tooltip.contains(document.activeElement);
    tooltip.classList.remove('is-visible');
    tooltip.setAttribute('aria-hidden', 'true');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (trigger && shouldRestoreFocus) trigger.focus();
  }

  function closeAll() {
    document.querySelectorAll(TOOLTIP + '.is-visible').forEach((t) => close(t));
  }

  function reposition() {
    document.querySelectorAll(TRIGGER).forEach((trigger) => {
      const tooltip = getTooltip(trigger);
      if (tooltip && (tooltip.classList.contains('is-visible') || getComputedStyle(tooltip).visibility === 'visible')) {
        position(trigger, tooltip);
      }
    });
  }

  let hoverCloseTimeout = null;

  document.addEventListener('mouseover', (e) => {
    const trigger = e.target.closest(TRIGGER);
    if (trigger) {
      const tooltip = getTooltip(trigger);
      if (tooltip) {
        if (hoverCloseTimeout) {
          clearTimeout(hoverCloseTimeout);
          hoverCloseTimeout = null;
        }
        open(trigger, tooltip);
      }
      return;
    }
    const tooltipEl = e.target.closest(TOOLTIP);
    if (tooltipEl) position(document.querySelector(`[aria-describedby="${tooltipEl.id}"]`), tooltipEl);
  });

  const HOVER_CLOSE_DELAY_MS = 400;

  document.addEventListener('mouseout', (e) => {
    const wrapper = e.target.closest(WRAPPER);
    if (!wrapper) return;
    const related = e.relatedTarget;
    if (related && wrapper.contains(related)) return;
    const tooltip = wrapper.querySelector(TOOLTIP);
    if (!tooltip || !tooltip.classList.contains('is-visible')) return;
    if (hoverCloseTimeout) clearTimeout(hoverCloseTimeout);
    hoverCloseTimeout = setTimeout(() => {
      close(tooltip);
      hoverCloseTimeout = null;
    }, HOVER_CLOSE_DELAY_MS);
  });
  document.addEventListener('focusin', (e) => {
    const trigger = e.target.closest(TRIGGER);
    if (trigger) {
      const tooltip = getTooltip(trigger);
      if (tooltip) open(trigger, tooltip);
    }
  });
  document.addEventListener('focusout', (e) => {
    const wrapper = e.target.closest(WRAPPER);
    if (!wrapper) return;
    requestAnimationFrame(() => {
      if (!wrapper.contains(document.activeElement)) {
        const t = wrapper.querySelector(TOOLTIP);
        if (t) close(t);
      }
    });
  });
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest(TRIGGER);
    if (trigger) {
      const tooltip = getTooltip(trigger);
      if (tooltip) {
        const willOpen = !tooltip.classList.contains('is-visible');
        willOpen ? open(trigger, tooltip) : close(tooltip);
      }
      return;
    }
    if (e.target.closest(TOOLTIP)) return;
    closeAll();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
  window.addEventListener('scroll', reposition, true);
  window.addEventListener('resize', reposition);
})();
